import { useLocation, useRoute } from 'wouter-preact'

import { Typography } from 'components/UI/atoms'

type Props = {
	closeMenu: () => void
	href: string
	hrefNewTab: string
	title: string
	onClick?: (e: MouseEvent) => void
}

// TODO: Same behavior as packages/web/src/components/UI/organisms/sidebar/SidebarItem.tsx
const DropdownItem = ({
	closeMenu,
	title,
	href,
	hrefNewTab,
	onClick
}: Props) => {
	const [, navigate] = useLocation()
	const [isOnWorkspacePage] = useRoute('/smart-contract/:dAppName/workspace')

	const handleClick = (e: MouseEvent) => {
		if (onClick) {
			onClick(e)
			return
		}

		closeMenu()

		if (isOnWorkspacePage) {
			window.open(hrefNewTab, '_blank', 'noopener noreferrer')
			return
		}

		navigate(href)
	}

	return (
		<button
			aria-label='Go to'
			class='w-full px-4 py-3 text-start'
			onClick={handleClick}
			type='button'
		>
			<Typography text={title} variant='text3' />
		</button>
	)
}

export { DropdownItem }
